import { Requester } from './Requester';
import { ISurveyBatch, BatchResponse } from '../types';

export const PutSurveyBatch = async (surveyBatch: ISurveyBatch): Promise<BatchResponse | null> => {
    const { surveyTrigger, ...batchData } = surveyBatch;

    try {
        const response = await Requester<BatchResponse | null>({
            path: `surveys/batch/${surveyTrigger}`,
            method: 'PUT',
            payload: batchData
        });

        return response && ('omittedLoanGroups' in response || 'omittedOrganizations' in response) ? response : null;
    } catch (e) {
        console.error('Generate survey batch request failed');
        return Promise.reject(e);
    }
};
